import { createSelector } from '@ngrx/store';
import { DivisionBasedPostCodeInfo } from '../interfaces/shared.interface';
import { CurrencyCode, Division } from '../../shared/enums';
import { selectFeatureStore } from './generic.selectors';

export const selectStaffDetails = createSelector(
  selectFeatureStore,
  ({ staffDetails }) => staffDetails,
);

export const selectStaffNumber = createSelector(
  selectStaffDetails,
  ({ staffNumber }) => staffNumber,
);

export const selectName = createSelector(selectStaffDetails, ({ name }) =>
  name.slice(0, name.indexOf(' ')),
);

export const selectPreviousLoginDate = createSelector(
  selectStaffDetails,
  ({ previousLoginDate }) => previousLoginDate,
);

export const selectDivision = createSelector(
  selectStaffDetails,
  ({ division }) => division,
);

export const selectHasNMCSkill = createSelector(
  selectStaffDetails,
  ({ hasNmcSkill }) => hasNmcSkill,
);

export const selectHasNMBISkill = createSelector(
  selectStaffDetails,
  ({ hasNmbiSkill }) => hasNmbiSkill,
);

export const selectCompanyDescriptorsForNMCNMBIScheme = createSelector(
  selectStaffDetails,
  ({ division }) => ({
    companyDescriptor:
      division === Division.tns
        ? 'Thornbury Nursing Services'
        : 'Scottish Nursing Guild',
    nmcNmbiCompanyDescriptor:
      division === Division.tns
        ? 'Thornbury Nursing Services'
        : 'the Scottish Nursing Guild',
  }),
);

export const selectDivisionCurrencyCode = createSelector(
  selectDivision,
  (division): CurrencyCode => {
    if (division === Division.roi) return 'EUR';
    return 'GBP';
  },
);

export const selectDivisionBasedPostCodeInfo = createSelector(
  selectDivision,
  (division): DivisionBasedPostCodeInfo => ({
    division,
    postcodeLabel: division === Division.roi ? 'eircode' : 'postcode',
    postcodeSuggestion: division === Division.roi ? 'A65 F4E2' : 'BN7 1BX',
  }),
);

export const selectHasUniformSkill = createSelector(
  selectStaffDetails,
  ({ hasUniformSkill }) => hasUniformSkill,
);

export const selectShowPromotionUniform = createSelector(
  selectDivision,
  selectHasUniformSkill,
  (division, hasUniformSkill) => division !== Division.roi && hasUniformSkill,
);
